import { V2Empty } from '../V2Empty.jsx';

export function V2Archivist({ archivistEvs = [] }) {
  if (!archivistEvs.length) {
    return <V2Empty message="Archivist is silent." />;
  }
  return (
    <div className="v2-archivist" data-testid="v2-archivist">
      {archivistEvs.map((ev, i) => (
        <div key={i} className="v2-archivist-row">
          <span className="v2-archivist-verb">{ev.verb}</span>
          {ev.candidateURN && <code className="v2-archivist-urn">{ev.candidateURN}</code>}
        </div>
      ))}
    </div>
  );
}
